import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

// import CapacityBar from './capacity_bar'
import AlbumListItem from "./album_list_item";
import Loader from "../loader";
import ModalAlbumCreate from "./modal_album_create";
import ModalConfirm from "../modal/modal_confirm";
import ModalAlert from "../modal/modal_alert";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    circleId: PropTypes.number.isRequired,
    userId: PropTypes.number.isRequired,
    chargePlanType: PropTypes.number.isRequired,
    photoStrageLimit: PropTypes.number.isRequired,
    publicTypeData: PropTypes.object.isRequired,
    albumInitialTitle: PropTypes.string.isRequired,
    isCirclePrivate: PropTypes.bool.isRequired,
    myMemberType: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      allFileCapacity: 0,
      albums: {},
      loading: true,
      isAlbumCreatModalOpen: false,
      fadeClassName: "fade-in",
      isDeleteMode: false,
      scrollPos: 0,
      selectedAlbumId: 0,
    };
  },
  componentDidMount() {
    // this.loadAllFileCapacityFromServer();
    this.loadAlbumsFromServer();
  },
  changeDeleteMode() {
    this.setState({
      isDeleteMode: !this.state.isDeleteMode,
    });
  },
  openModal() {
    var scrollPos = $("body").scrollTop();
    var marginLeft =
      (window.innerWidth - $("body .container").outerWidth()) / 2;
    $("body").css({
      position: "fixed",
      marginTop: -scrollPos,
      marginLeft: marginLeft,
    });
    this.setState({
      isAlbumCreatModalOpen: true,
      fadeClassName: "fade-in",
      scrollPos: scrollPos,
    });
  },
  closeModal() {
    $("body").css({ position: "relative", marginTop: "0", marginLeft: "0" });
    $("body").scrollTop(this.state.scrollPos);
    this.setState({
      fadeClassName: "fade-out",
    });
    setTimeout(
      function() {
        this.setState({
          isAlbumCreatModalOpen: false,
        });
      }.bind(this),
      300
    );
  },
  loadAllFileCapacityFromServer() {
    // // 有料プランの場合はファイル容量を取得しない
    // if (this.props.chargePlanType != 0) {
    //   return;
    // }
    // $.ajax({
    //   url: '/api/album/get_all_file_capacity',
    //   type : 'POST',
    //   data: {
    //     circle_id: this.props.circleId
    //   },
    //   cache: false,
    //   success: function(data) {
    //     var capacity = Number(data);
    //     this.setState({
    //       allFileCapacity: capacity
    //     });
    //     // 値を取得できなかった場合の対応
    //   }.bind(this),
    //   error: function(xhr, status, err) {
    //     // ネットワークエラー対応
    //   }.bind(this)
    // });
  },
  loadAlbumsFromServer() {
    $.ajax({
      url: "/api/album/load_albums",
      type: "POST",
      data: {
        circle_id: this.props.circleId,
      },
      cache: false,
      success: function(data) {
        this.setState({
          albums: data,
          loading: false,
        });
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  deleteAlbumFromServer() {
    $.ajax({
      url: "/api/album/delete_album",
      type: "POST",
      dataType: "json",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        album_id: this.state.selectedAlbumId,
      },
      cache: false,
      success: function(data) {
        if (data) {
          this.loadAlbumsFromServer();
          this.loadAllFileCapacityFromServer();
        } else {
          this.modalAlertError.openModal();
        }
      }.bind(this),
      error: function() {
        this.modalAlertNetworkError.openModal();
      }.bind(this),
    });
  },
  deleteAlbum() {
    this.deleteAlbumFromServer();
  },
  albumSelected(e) {
    this.setState({
      selectedAlbumId: e,
    });
    this.modalConfirmDelete.openModal();
  },
  showAlbumCreateError() {
    this.modalAlertAlbumCreateError.openModal();
  },
  showNetworkError() {
    this.modalAlertNetworkError.openModal();
  },
  showPublicSettingError() {
    this.modalAlertPublicSettingError.openModal();
  },
  showStrageError() {
    this.modalAlertStrageError.openModal();
  },
  render() {
    // var capacityBar = '';
    // if (this.props.chargePlanType == 0) {
    //   capacityBar = <CapacityBar
    //     photoStrageLimit = {this.props.photoStrageLimit}
    //     allFileCapacity = {this.state.allFileCapacity}
    //   />;
    // }
    var albumListItems = [];
    Object.keys(this.state.albums).forEach(function(key) {
      if (
        this.props.myMemberType !== 1 &&
        this.state.albums[key].public_type !== 4
      ) {
        return;
      }
      albumListItems.unshift(
        <AlbumListItem
          key={key}
          albumId={Number(key)}
          circleId={this.props.circleId}
          album={this.state.albums[key]}
          publicTypeData={this.props.publicTypeData}
          isDeleteMode={this.state.isDeleteMode}
          loadAlbumsFromServer={this.loadAlbumsFromServer}
          loadAllFileCapacityFromServer={this.loadAllFileCapacityFromServer}
          albumSelected={this.albumSelected}
        />
      );
    }, this);
    if (this.state.loading) {
      return (
        <div>
          {/* {capacityBar} */}
          <div className="display-1 ml-3 mt-4 mb-4 border-bottom">
            <h4 className="h4">アルバム</h4>
          </div>
          <Loader isActive={this.state.loading} />
        </div>
      );
    }
    let deleteModeButtonColor = this.state.isDeleteMode ? "#000" : "#cacaca";
    let initialPublicType = this.props.isCirclePrivate ? 2 : 4;
    return (
      <div className="album container overflow-hidden">
        <ModalAlbumCreate
          isOpen={this.state.isAlbumCreatModalOpen}
          closeModal={this.closeModal}
          fadeClassName={this.state.fadeClassName}
          publicTypeData={this.props.publicTypeData}
          initialTitle={this.props.albumInitialTitle}
          initialPublicType={initialPublicType}
          circleId={this.props.circleId}
          userId={this.props.userId}
          allFileCapacity={this.state.allFileCapacity}
          photoStrageLimit={this.props.photoStrageLimit}
          chargePlanType={this.props.chargePlanType}
          isCirclePrivate={this.props.isCirclePrivate}
          showAlbumCreateError={this.showAlbumCreateError}
          showNetworkError={this.showNetworkError}
          showPublicSettingError={this.showPublicSettingError}
          showStrageError={this.showStrageError}
        />
        {/* {capacityBar} */}
        <div className="display-1 ml-3 mt-4 mb-4 border-bottom">
          <h4 className="h4 mb-1">アルバム</h4>
          {this.props.myMemberType === 1 ? (
            <div style={{ fontSize: "25px", paddingBottom: "8px" }}>
              <a
                className={this.state.isDeleteMode ? "shake" : ""}
                onClick={this.changeDeleteMode}
                style={{
                  float: "right",
                  marginTop: "-23px",
                  color: deleteModeButtonColor,
                }}
              >
                <i className="fas fa-trash-alt" aria-hidden="true" />
              </a>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="sorting-block">
          <div className="sorting-grid">
            {this.props.myMemberType === 1 ? (
              <li
                className="col-md-3 col-sm-3 col-xs-4"
                style={{ padding: "0px" }}
              >
                <div className="album-list-item">
                  <div className="album-list" onClick={this.openModal}>
                    <div className="album-top-photo-wrap">
                      <a
                        className="photo-h"
                        style={{ textAlign: "center", color: "#ccc" }}
                      >
                        <br />
                        <i
                          className="fas fa-plus"
                          aria-hidden="true"
                          style={{ fontSize: "40px" }}
                        />
                      </a>
                    </div>
                  </div>
                  <a className="album-info">
                    <p
                      style={{
                        margin: "0px 5px",
                        textAlign: "center",
                        color: "#ccc",
                      }}
                    >
                      新規作成
                    </p>
                    <p />
                  </a>
                </div>
              </li>
            ) : (
              ""
            )}
            {albumListItems}
          </div>
        </div>
        <ModalConfirm
          ref={(c) => {
            this.modalConfirmDelete = c;
          }}
          title="アルバムの削除"
          content="元に戻すことはできません。よろしいですか？"
          approveFunc={this.deleteAlbum}
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertError = c;
          }}
          title="エラー"
          content="アルバムの削除に失敗しました。時間を置いてもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertNetworkError = c;
          }}
          title="エラー"
          content="ネットワークエラーが発生しました。ネットワークの接続を確認し、もう一度試してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertAlbumCreateError = c;
          }}
          title="エラー"
          content="アルバムの作成に失敗しました。後でもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertPublicSettingError = c;
          }}
          title="公開範囲"
          content="サークルの公開設定が「非公開」なので、公開範囲を「サークルメンバー」でアルバムを保存することができません。サークルの公開設定を「公開」にするか、アルバムの公開範囲を「サークルメンバー」に設定してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertStrageError = c;
          }}
          title="容量制限"
          content="プライベートストレージの制限を超えているので、公開範囲を「サークルメンバー」でアルバムを保存することができません。アルバムの公開範囲を「公開」に設定するか、他の画像を削除してください。また、有料プランに加入するとプライベートストレージの制限を解除できます。"
        />
      </div>
    );
  },
});
